import AllCampaignsPage from "@/pages/companyDashboard/AllCampaignsPage";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/campaigns/$status")({
  component: AllCampaignsPage,
  params: {
    parse: ({agencyId, companyId, status}) => ({
      agencyId: Number(agencyId),
      companyId: Number(companyId),
      status: z.enum(["active", "complete", "paused", "planned", "open"]).parse(status),
    }),
    stringify: ({agencyId, companyId, status}) => ({
      agencyId: String(agencyId),
      companyId: String(companyId),
      status,
    }),
  },
});
